<template>
  <li class="c-profile-menu d-flex align-items-center ms-4">
    <input
      :id="`profile-avatar-${ device }`"
      class="c-profile-dropdown-cbox d-none"
      type="checkbox"
      v-model="switcher"
    />
    <label
      @mouseover="blockMenu(true)" @mouseleave="blockMenu(false)"
      :for="`profile-avatar-${ device }`"
      class="c-avatar c-avatar--tiny position-relative"
      :class="[classRoles, {'c-avatar--subscriber' : body.membership}]">
      <div
        v-if="body.roles.includes('team') || body.roles.includes('education')
          || body.roles.includes('core') || body.roles.includes('agent')"
        class="c-avatar__badge rounded bg-warnings white position-absolute
          d-flex justify-content-center align-items-center"
      >
        <i class="d-flex align-items-center iconf-user fs-14"></i>
      </div>
      <div
        v-else-if="body.roles.includes('teacher') || body.roles.includes('teacher-pro')"
        class="c-avatar__badge rounded bg-warnings white position-absolute
          d-flex justify-content-center align-items-center"
      >
        <i class="d-flex align-items-center iconf-graduation-cap fs-14"></i>
      </div>
      <div
        v-else-if="isAdminUser" class="c-avatar__badge rounded bg-warnings white position-absolute
          d-flex justify-content-center align-items-center"
      >
        <i class="d-flex align-items-center iconf-config fs-14"></i>
      </div>
      <div
        v-else-if="body.membership"
        class="c-avatar__badge rounded bg-warnings white position-absolute
          d-flex justify-content-center align-items-center"
      >
        <i class="d-flex align-items-center iconf-king fs-14"></i>
      </div>
      <figure class="c-avatar__image rounded overflow-hidden">
        <img
          :src="body.photo"
          class="avatar avatar-thumbnail w-100 h-100 of--cover"
          :alt="body.name"
        />
      </figure>
    </label>
    <div
      @mouseover="blockMenu(true)"
      @mouseleave="blockMenu(false)"
      class="c-profile-dropdown p-3 bg-white position-absolute"
    >
      <div class="d-flex flex-column align-items-center mb-4">
        <div class="c-avatar c-avatar--medium mb-3">
          <a
            href="/panel"
            class="c-avatar__image d-block rounded overflow-hidden">
            <img :src="body.photo" class="avatar avatar-thumbnail w-100 h-100" :alt="body.name"/>
          </a>
        </div>
        <a
          href="/panel"
          class="w-bold c-link text-center mb-0"
        >
          {{ body.first_name }}
        </a>
        <p class="c-profile-dropdown__email w-medium sec-color mb-0 text-center">
          {{ body.email }}
        </p>
      </div>
      <div class="c-hr bg-light-gray mb-4"></div>
      <ul class="c-profile-dropdown__menu ul-reset">
        <li v-if="isAdminUser" class="c-profile-dropdown__item mb-3">
          <a href="/wp/wp-admin/" class="d-flex align-items-center" target="_blank">
            <i class="c-icon iconf-admin me-3"></i>
            Administrador
          </a>
        </li>
        <li class="c-profile-dropdown__item mb-3">
          <a href="/panel/membresia" class="d-flex align-items-center">
            <i class="c-icon iconf-king me-3"></i>
            Mi membresía
          </a>
        </li>
        <li v-if="body.workProfile" class="c-profile-dropdown__item mb-3">
          <b-skeleton-wrapper :loading="body.workProfile.loading">
            <template #loading>
              <b-skeleton
                no-aspect
                animation="fade"
                width="100%"
                class="light"
              ></b-skeleton>
            </template>

            <a
              v-if="body.workProfile.data"
              :href="`/es/profesionales/${body.workProfile.data.slug}`"
              class="d-flex align-items-center"
            >
              <Icon icon="uil:bag-alt" class="c-icon me-3 fs-25" />
              Arcux Connecta
              <span class="bg-third-color fs-14 w-medium br--small ms-2 white px-1">Nuevo</span>
            </a>
          </b-skeleton-wrapper>
        </li>
        <li class="c-profile-dropdown__item mb-3">
          <a href="/panel" class="d-flex align-items-center">
            <i class="c-icon iconf-course me-3"></i>
            Mis cursos
          </a>
        </li>
        <li class="c-profile-dropdown__item mb-3">
          <a href="/panel/editar" class="d-flex align-items-center">
            <i class="c-icon iconf-pen me-3"></i>
            Editar perfil
          </a>
        </li>
        <li class="c-profile-dropdown__item c-profile-dropdown__item--logout">
          <a @click="logout($event)" href="#" class="d-flex align-items-center">
            <i class="c-icon iconf-logout me-3"></i>
            Cerrar sesión
          </a>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import { mapActions } from 'vuex';
import { clearSession } from '../libs/auth';

export default {
  data() {
    return {
      project: window.arcux.project,

      switcher: false,
      isActiveMenu: false,
    };
  },
  props: ['body', 'device'],
  computed: {
    isAdminUser() {
      return (this.body)
        ? (this.body.roles.includes('team')
            || this.body.roles.includes('education')
            || this.body.roles.includes('core')
            || this.body.roles.includes('administrator')
            || this.body.roles.includes('teacher')
            || this.body.roles.includes('teacher-pro')
        )
        : false;
    },

    classRoles() {
      return this.body.roles.map((role) => `c-avatar--${role}`);
    },
  },
  watch: {
    switcher() {
      document.onclick = () => {
        this.unblockMenu();
      };
    },
  },
  mounted() {
    this.getWorkProfile();
  },
  methods: {
    clearSession,
    ...mapActions([
      'updateUserData',
    ]),

    blockMenu(state) {
      if (state) {
        this.isActiveMenu = true;
      } else {
        this.isActiveMenu = false;
      }
    },
    unblockMenu() {
      if (!this.isActiveMenu) {
        this.switcher = false;
      }
    },

    getWorkProfile() {
      this.updateUserData({
        userData: {
          ...this.body,
          workProfile: { data: null, loading: true },
        },
      });

      fetch(`${process.env.VUE_APP_API_V2}/work/profiles/${this.body.id}?mode=simple`)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            this.updateUserData({
              userData: {
                ...this.body,
                workProfile: { data: response.data, loading: false },
              },
            });
          } else {
            this.updateUserData({
              userData: {
                ...this.body,
                workProfile: { data: null, loading: false },
              },
            });
          }
        })
        .catch(() => {
          this.updateUserData({
            userData: {
              ...this.body,
              workProfile: { data: null, loading: false },
            },
          });
        });
    },

    logout(e) {
      e.preventDefault();

      this.clearSession(2);
    },
  },
};
</script>
